import {AlertComponentPropsWithStyle } from 'react-alert'
import { IconErrorBig, IconInfoBig, IconSuccessBig } from "../../../assets/icons/index"

export interface AlertTemplateProps extends AlertComponentPropsWithStyle { }

const AlertTemplateComponent = (props: AlertTemplateProps) => {
  const {
    message,
    options: { type }
  } = props

  const getIcon = () => {
    switch (type) {
      case 'info':
        return IconInfoBig
      case 'success':
        return IconSuccessBig
      case 'error':
        return IconErrorBig
      default:
        return null
    }
  }
  const icon = getIcon()

  const IconComponent = icon;

  return (
    <div
      style={{
    display: 'flex',
    justifyContent: 'space-between',
    color: 'white',
    backgroundColor: 'white',
    fontWeight: 500,
    fontSize: '14px',
    minWidth: '200px',
    margin: '0 0 20px 25px',
    borderRadius: '10px',
    boxShadow: '0 0 20px -10px black',
      }}
    >
      <div style={{padding: '20px 15px',
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    color: '#11174b',
    fontSize: '16px'}}>
        {/* <Icon icon={icons[type] || ''} className={styles.messageIcon} /> */}
        {IconComponent && <IconComponent style={{ marginRight: '10px' }} />}
        {message}
      </div>
    </div>
  )
}

AlertTemplateComponent.defaultProps = {
  message: 'Alert message...',
  options: {
    type: 'info'
  }
} as AlertTemplateProps

const AlertTemplate = AlertTemplateComponent
export { AlertTemplate }